import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class ThemeSettingsService {

  currentTheme = 'dark-theme';
  private theme = new BehaviorSubject<string>( this.currentTheme );
  theme$: Observable<string> = this.theme.asObservable();

  constructor () { }

  changeTheme ( theme: string ) {
    this.currentTheme = theme;
    this.theme.next( theme );
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/theme-settings.service.ts